var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "mb-4", attrs: { id: "google_signin" } }),
      _vm._v(" "),
      _c("div", {
        attrs: {
          id: "appleid-signin",
          "data-mode": "center-align",
          "data-type": "sign-in",
          "data-color": "white",
          "data-border": "true",
          "data-border-radius": "4",
          "data-width": "178",
          "data-height": "38",
          "data-logo-size": "small",
          "data-logo-position": "5",
          "data-label-position": "5",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }